import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { MOBILE_BREAK } from 'src/utils/consts'
import UseCaseIntroFrame from 'src/components/use-case-intro-frame'

export class DesktopUseCases extends Component {
  static propTypes = {
    className: PropTypes.string,
    windowWidth: PropTypes.number.isRequired,
    shouldShowUseCases: PropTypes.bool.isRequired,
    currentUseCase: PropTypes.object,
  }

  static defaultProps = {
    className: '',
    currentUseCase: null,
  }

  get className() {
    const { className, shouldShowUseCases, windowWidth } = this.props
    const isMobile = windowWidth <= MOBILE_BREAK
    return c('im-desktop-use-cases', shouldShowUseCases && 'visible', isMobile && 'is-mobile', className)
  }

  render() {
    const { className } = this
    const { currentUseCase } = this.props
    return <div className={className}>{currentUseCase && <UseCaseIntroFrame />}</div>
  }
}

export default connect(state => ({
  windowWidth: state.windowWidth,
  shouldShowUseCases: state.shouldShowUseCases,
  currentUseCase: state.currentUseCase,
}))(DesktopUseCases)
